/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
// @flow

import { createBrowserHistory } from 'history';

const createHistory = createBrowserHistory();

createHistory.listen((location, action) => {
  window.scrollTo(0, 0);
});

export default createHistory;
